// extracted by mini-css-extract-plugin
export default {"timeline":"StickTime_timeline__VShAE","card":"StickTime_card__yDxLN","info":"StickTime_info__Q4kES","title":"StickTime_title__bFAuI","betweenTime":"StickTime_betweenTime__vQcWL"};